import ResignCertificates from "../../../../components/company/workforce/resigned/ResignCertificates";

export default function FnFLetterPage(){
    return <ResignCertificates title="Fool & Final Letter"/>
}